module.exports = __webpack_public_path__ + "img/hagerup_Skoddeland1.04b70b49.jpg";